import React from "react";

function Faqques({ ques, para }) {
  return (
    <div className="faq-ques-box">
      <div className="faq-ques">
        <h2>{ques}</h2>
      </div>
      <div className="faq-para">
        <p>{para}</p>
      </div>
    </div>
  );
}

export default Faqques;
